/* ==========================================================================
   RAVAGE — theme behaviour
   No framework, no build step. Everything is progressive: the store works
   with JS off (forms post normally, links navigate); JS upgrades it.
   ========================================================================== */
(function () {
  'use strict';

  var cfgEl = document.getElementById('ravage-config');
  var CFG = cfgEl ? JSON.parse(cfgEl.textContent) : {};
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  var S = CFG.strings || {};

  function money(cents) {
    var fmt = CFG.moneyFormat || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }

  var ESCAPES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) { return ESCAPES[c]; });
  }

  /* ── dialogs: focus trap, focus restore, scroll lock ─────────────────── */
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),' +
                  'textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  var openDialog = null;   // the drawer or modal currently on top
  var lastFocus = null;    // what to hand focus back to when it closes

  function focusables(root) {
    return $$(FOCUSABLE, root).filter(function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0;
    });
  }

  function captureDialog(el, bodyClass) {
    lastFocus = document.activeElement;
    openDialog = el;
    document.body.classList.add(bodyClass);
    requestAnimationFrame(function () {
      var first = focusables(el)[0];
      if (first) first.focus();
    });
  }

  function releaseDialog(bodyClass) {
    openDialog = null;
    document.body.classList.remove(bodyClass);
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
    lastFocus = null;
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !openDialog) return;
    var f = focusables(openDialog);
    if (!f.length) { e.preventDefault(); return; }
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ── cart drawer ─────────────────────────────────────────────────────── */
  var drawer = $('#cart-drawer');
  var scrim  = $('#scrim');

  function cartIsOpen() { return !!drawer && drawer.classList.contains('is-on'); }

  function openCart() {
    if (!drawer || !CFG.cartDrawer || cartIsOpen()) return !!(drawer && CFG.cartDrawer);
    drawer.classList.add('is-on');
    drawer.setAttribute('aria-hidden', 'false');
    if (scrim) { scrim.hidden = false; requestAnimationFrame(function () { scrim.classList.add('is-on'); }); }
    captureDialog(drawer, 'cart-open');
    return true;
  }
  function shutCart() {
    if (!cartIsOpen()) return;
    drawer.classList.remove('is-on');
    drawer.setAttribute('aria-hidden', 'true');
    if (scrim) {
      scrim.classList.remove('is-on');
      setTimeout(function () { scrim.hidden = true; }, 350);
    }
    releaseDialog('cart-open');
  }

  function paintShipping(total) {
    var msg = $('#ship-msg'), bar = $('#ship-bar');
    if (!msg || !bar) return;
    var target = CFG.freeShippingThreshold || 0;
    if (!target) return;
    var left = Math.max(0, target - total);
    msg.textContent = left > 0
      ? (S.shipProgress || 'Add [[amount]] for free shipping').replace('[[amount]]', money(left))
      : (S.shipUnlocked || 'Free shipping unlocked');
    bar.style.width = Math.min(100, (total / target) * 100) + '%';
  }

  /* One place that repaints every cart-derived bit of chrome. */
  function paintCart(cart) {
    renderItems(cart);
    var count = $('#cart-count');
    if (count) count.textContent = cart.item_count;
    var opener = $('[data-cart-open]');
    if (opener) opener.setAttribute('aria-label', (S.cart || 'Cart') + ' (' + cart.item_count + ')');
    var total = $('#cart-total');
    if (total) total.textContent = money(cart.total_price);
    paintShipping(cart.total_price);
    var checkout = drawer && drawer.querySelector('button[name="checkout"]');
    if (checkout) checkout.disabled = cart.item_count === 0;
  }

  /* Re-render the drawer body straight from the cart JSON — avoids depending
     on the Section Rendering API being wired for a snippet. */
  function renderItems(cart) {
    var body = $('#cart-items');
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<div class="empty"><p class="m">' + esc(S.empty || 'Your cart is empty') + '</p></div>';
      return;
    }
    var remove = esc(S.remove || 'Remove');
    body.innerHTML = cart.items.map(function (l, i) {
      var img = l.image
        ? '<img src="' + esc(l.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2')) + '" alt="" loading="lazy">'
        : '<svg class="plate" viewBox="0 0 1000 700" aria-hidden="true"><use href="#plate"></use></svg>';
      var variant = /default/i.test(l.variant_title || '') ? '' : (l.variant_title || '');
      var title = esc(l.product_title);
      return '<div class="li" data-line="' + (i + 1) + '">' +
        '<div class="li__img">' + img + '</div>' +
        '<div><b><a href="' + esc(l.url) + '">' + title + '</a></b>' +
        '<span class="meta">' + esc(variant) + '</span>' +
        '<div class="row"><span class="meta">' + esc(money(l.final_price)) + ' × ' + l.quantity + '</span>' +
        '<button class="rm" type="button" data-line-remove="' + (i + 1) + '" ' +
        'aria-label="' + remove + ' — ' + title + '">' + remove + '</button></div></div></div>';
    }).join('');
  }

  function changeLine(line, quantity) {
    return fetch(CFG.routes.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(paintCart);
  }

  function addToCart(id, qty) {
    return fetch(CFG.routes.cart_add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
    }).then(function (r) { return r.json(); }).then(function () {
      return fetch(CFG.routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          paintCart(cart);
          openCart();
        });
    });
  }

  /* ── modals ──────────────────────────────────────────────────────────── */
  function openModal(m) {
    if (!m || !m.hidden) return;
    m.hidden = false;
    requestAnimationFrame(function () { m.classList.add('is-on'); });
    captureDialog(m, 'modal-open');
  }
  function shutModals() {
    var wasOpen = false;
    $$('.modal').forEach(function (m) {
      if (m.hidden) return;
      wasOpen = true;
      m.classList.remove('is-on');
      setTimeout(function () { m.hidden = true; }, 300);
    });
    if (wasOpen) releaseDialog('modal-open');
  }

  /* ── delegated clicks ────────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var t = e.target;

    if (t.closest('[data-cart-open]')) { if (openCart()) e.preventDefault(); return; }
    if (t.closest('[data-cart-close]') || t === scrim) { shutCart(); return; }

    var quick = t.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      if (quick.disabled) return;              // no double-add on an impatient double-click
      quick.disabled = true;
      addToCart(quick.getAttribute('data-quick-add'), 1)
        .catch(function () { window.location.href = CFG.routes.cart; })
        .then(function () { quick.disabled = false; });
      return;
    }

    var del = t.closest('[data-address-delete]');
    if (del && !window.confirm(del.getAttribute('data-address-delete'))) { e.preventDefault(); return; }

    var rm = t.closest('[data-line-remove]');
    if (rm) {
      e.preventDefault();
      changeLine(Number(rm.getAttribute('data-line-remove')), 0).then(function () {
        // the button that had focus was just re-rendered away
        if (openDialog === drawer) {
          var next = focusables(drawer)[0];
          if (next) next.focus();
        }
      });
      return;
    }

    var openM = t.closest('[data-modal-open]');
    if (openM) {
      e.preventDefault();
      openModal(document.getElementById('modal-' + openM.getAttribute('data-modal-open')));
      return;
    }
    if (t.closest('[data-modal-close]') || t.classList.contains('modal')) { shutModals(); return; }

    var nav = t.closest('[data-mobile-nav]');
    if (nav) {
      var panel = $('#mobile-nav');
      if (panel) {
        panel.hidden = !panel.hidden;
        nav.setAttribute('aria-expanded', String(!panel.hidden));
      }
      return;
    }

    var acc = t.closest('.acc-item > button');
    if (acc) {
      var open = !acc.parentElement.classList.contains('is-open');
      acc.parentElement.classList.toggle('is-open', open);
      acc.setAttribute('aria-expanded', String(open));
      syncAcc();
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    shutCart();
    shutModals();
  });

  /* ── product page ────────────────────────────────────────────────────── */
  var root = $('[data-product-root]');
  if (root) {
    var select = $('[data-variant-select]', root);
    var qtyInput = $('input[name="quantity"]', root);
    var qtyVal = $('#qty-val');
    var price = $('#pdp-price');
    var addPrice = $('#add-price');
    var qty = 1;

    function currentOption() { return select && select.options[select.selectedIndex]; }

    function markThumb(active) {
      $$('.thumb', root).forEach(function (b) {
        b.classList.remove('is-on');
        b.setAttribute('aria-current', 'false');
      });
      active.classList.add('is-on');
      active.setAttribute('aria-current', 'true');
    }

    var compare = $('#pdp-compare');
    var stickyPrice = $('#sticky-price');
    var stickyAdd = $('[data-sticky-add]');
    var stock = $('[data-stock]', root);
    var dimW = $('#dim-w');
    var dimH = $('#dim-h');

    /* syncStock is deliberately opt-in. Running availability on page load once
       disabled every button on a product reached without ?variant= — trust the
       server's rendered state and only re-sync after an explicit variant pick. */
    function paintPrice(syncStock) {
      var opt = currentOption();
      if (!opt) return;
      var p = opt.getAttribute('data-price');
      if (price) price.textContent = p;
      if (addPrice) addPrice.textContent = p;
      if (stickyPrice) stickyPrice.textContent = p;

      if (compare) {
        var c = opt.getAttribute('data-compare');
        compare.textContent = c || '';
        compare.hidden = !c;
      }
      if (!syncStock) return;

      var avail = opt.getAttribute('data-available') === 'true';
      var submit = root.querySelector('button[type="submit"][name="add"]');
      if (submit) submit.disabled = !avail;
      if (stickyAdd) stickyAdd.disabled = !avail;
      if (stock) {
        var mark = stock.querySelector('i');
        stock.textContent = ' ' + (avail ? (S.inStock || 'In stock') : (S.soldOut || 'Sold out'));
        if (mark) stock.insertBefore(mark, stock.firstChild);
      }
    }

    function paintDims(btn) {
      if (dimW && btn.getAttribute('data-dim-w')) dimW.textContent = btn.getAttribute('data-dim-w');
      if (dimH && btn.getAttribute('data-dim-h')) dimH.textContent = btn.getAttribute('data-dim-h');
    }

    root.addEventListener('click', function (e) {
      var vb = e.target.closest('[data-variant]');
      if (vb && select) {
        select.value = vb.getAttribute('data-variant');
        select.dispatchEvent(new Event('change', { bubbles: true }));
        $$('[data-variant]', root).forEach(function (b) {
          b.classList.remove('is-on');
          b.setAttribute('aria-pressed', 'false');
        });
        vb.classList.add('is-on');
        vb.setAttribute('aria-pressed', 'true');
        paintPrice(true);
        paintDims(vb);
        return;
      }
      var qb = e.target.closest('[data-qty]');
      if (qb) {
        qty = Math.max(1, qty + Number(qb.getAttribute('data-qty')));
        if (qtyVal) qtyVal.textContent = qty;
        if (qtyInput) qtyInput.value = qty;
        return;
      }
      var thumb = e.target.closest('[data-media-src]');
      if (thumb) {
        var stage = $('#pdp-view');
        if (stage) {
          stage.innerHTML = '<img src="' + esc(thumb.getAttribute('data-media-src')) +
            '" alt="' + esc(thumb.getAttribute('data-media-alt')) + '">';
        }
        markThumb(thumb);
        var counter = $('#pdp-count');
        if (counter) {
          var idx = Number(thumb.getAttribute('data-media-index')) + 1;
          counter.textContent = ('0' + idx).slice(-2) + ' / ' + counter.textContent.split('/')[1].trim();
        }
        return;
      }
      var view = e.target.closest('[data-view]');
      if (view) {
        var stage2 = $('#pdp-view');
        if (stage2) stage2.innerHTML = view.innerHTML.replace(/<span>.*?<\/span>/, '');
        markThumb(view);
      }
    });

    var form = $('.product-form', root);
    if (form && CFG.cartDrawer) {
      form.addEventListener('submit', function (e) {
        if (!select) return;
        e.preventDefault();
        var btn = form.querySelector('button[type="submit"]');
        if (btn) btn.disabled = true;
        addToCart(select.value, qty)
          .catch(function () {
            // network died — fall back to the plain form post, which still works
            if (btn) btn.disabled = false;
            form.submit();
          })
          .then(function () { if (btn) btn.disabled = false; });
      });
    }

    /* Sticky buy bar — appears once the real buy row leaves the viewport.
       The button carries form="product-form" so it submits the one real form;
       if the platform ever renames that id, fall back to submitting directly. */
    var buyRow = $('[data-buy-row]', root);
    var sticky = $('[data-sticky-buy]');
    if (buyRow && sticky && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-on', !entries[0].isIntersecting);
      }, { threshold: 0 }).observe(buyRow);
    }
    if (stickyAdd && form && !document.getElementById(stickyAdd.getAttribute('form') || '')) {
      stickyAdd.addEventListener('click', function (e) {
        e.preventDefault();
        if (form.requestSubmit) { form.requestSubmit(); } else { form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })); }
      });
    }

    paintPrice(false);
  }

  /* ── address forms ───────────────────────────────────────────────────────
     Fills the province select from the chosen country's data-provinces, and
     hides it entirely for countries that don't have any. The select ships with
     the saved value pre-selected, so a JS-off submit still round-trips. */
  $$('[data-address-country]').forEach(function (country) {
    var province = country.form && country.form.querySelector('[data-address-province]');
    if (!province) return;
    var wrap = province.closest('.field');

    var preferred = country.getAttribute('data-default');
    if (preferred) country.value = preferred;

    function fill(keepSaved) {
      var opt = country.options[country.selectedIndex];
      var list = [];
      try { list = JSON.parse(opt.getAttribute('data-provinces') || '[]'); } catch (err) { list = []; }

      if (!list.length) {
        province.innerHTML = '';
        if (wrap) wrap.hidden = true;
        return;
      }
      if (wrap) wrap.hidden = false;

      var want = keepSaved ? province.getAttribute('data-default') : '';
      province.innerHTML = list.map(function (p) {
        return '<option value="' + esc(p[0]) + '"' + (p[0] === want ? ' selected' : '') + '>' + esc(p[1]) + '</option>';
      }).join('');
    }

    fill(true);
    country.addEventListener('change', function () { fill(false); });
  });

  /* ── accordions ──────────────────────────────────────────────────────── */
  function syncAcc() {
    $$('.acc-item').forEach(function (item) {
      var body = $('.acc-body', item);
      if (!body) return;
      body.style.maxHeight = item.classList.contains('is-open') ? body.scrollHeight + 'px' : '0px';
    });
  }
  syncAcc();
  window.addEventListener('resize', syncAcc);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncAcc);

  /* ── scroll reveal ───────────────────────────────────────────────────── */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.1 });
    $$('.rv').forEach(function (el) { io.observe(el); });
  } else {
    $$('.rv').forEach(function (el) { el.classList.add('in'); });
  }

  /* ── theme editor hooks ──────────────────────────────────────────────── */
  document.addEventListener('shopify:section:load', function () {
    $$('.rv').forEach(function (el) { el.classList.add('in'); });
    syncAcc();
  });

  if (drawer) paintShipping(0);
})();
